import { Button } from '@/components/ui/button';
import { ColumnDef } from '@tanstack/react-table';
import { ChevronDown, ChevronUp, Pencil, Trash } from 'lucide-react';
import RenderAvatarSvg from './render-avatar-svg';

export interface ServiceAvatar {
  shape: string;
  color1: string;
  color2: string;
}

interface ServiceAvatarColumnProps {
  onMoveAvatar: (index: number, direction: 'up' | 'down') => void;
  onEdit: (avatar: ServiceAvatar, index: number) => void;
  onDelete: (index: number) => void;
  totalItems: number;
}

export const getServiceAvatarColumns = ({
  onMoveAvatar,
  onEdit,
  onDelete,
  totalItems,
}: ServiceAvatarColumnProps): ColumnDef<ServiceAvatar>[] => [
  {
    id: 'preview',
    header: 'Preview',
    cell: ({ row }) => {
      const avatar = row.original;
      return (
        <div className="flex items-center">
          <RenderAvatarSvg
            shape={avatar.shape}
            color1={avatar.color1}
            color2={avatar.color2}
            size={40}
          />
        </div>
      );
    },
  },
  {
    header: 'Name',
    cell: ({ row }) => {
      const rownumber = row.index + 1;
      return <div className="flex items-center gap-2">Avatar {rownumber}</div>;
    },
  },
  {
    id: 'shape',
    header: 'Shape',
    cell: ({ row }) => {
      const avatar = row.original;
      return (
        <div className="flex items-center gap-2">
          {avatar.shape === 'halfTriangle' ? 'Triangle' : 'Square'}
        </div>
      );
    },
  },
  {
    id: 'colors',
    header: 'Colors',
    cell: ({ row }) => {
      const avatar = row.original;
      return (
        <div className="flex items-center gap-2">
          <div className="h-6 w-6 rounded-full border" style={{ backgroundColor: avatar.color1 }} />
          <div className="h-6 w-6 rounded-full border" style={{ backgroundColor: avatar.color2 }} />
        </div>
      );
    },
  },
  {
    id: 'actions',
    cell: ({ row }) => {
      const index = row.index;
      return (
        <div className="flex justify-end gap-2">
          {index > 0 && (
            <Button variant="ghost" size="icon" onClick={() => onMoveAvatar(index, 'up')}>
              <ChevronUp className="h-4 w-4" />
            </Button>
          )}
          {index < totalItems - 1 && (
            <Button variant="ghost" size="icon" onClick={() => onMoveAvatar(index, 'down')}>
              <ChevronDown className="h-4 w-4" />
            </Button>
          )}
          <Button variant="ghost" size="icon" onClick={() => onEdit(row.original, index)}>
            <Pencil className="h-4 w-4" />
          </Button>
          <Button variant="ghost" size="icon" onClick={() => onDelete(index)}>
            <Trash className="h-4 w-4" />
          </Button>
        </div>
      );
    },
  },
];
